import React, { useState, useMemo } from "react";
import { Box, Container, Grid, Typography, Stack } from "@mui/material";
import { skills } from "../../data/constants";
import SkillsKeyboard from "../SkillsKeyboard";

const wittyLines = {
  "React": "Mastering the virtual DOM since 16.8, hook line & sinker.",
  "Node Js": "Event-looping aggressively on the backend.",
  "Javascript": "Yeeting code into the DOM since '95, no cap!",
  "HTML": "The structural skeleton. Yes, it's a programming language in my heart.",
  "CSS": "Make it pretty, center the div, cry a little.",
  "Tailwind Css": "Utility-class soup never looked so good.",
  "MongoDB": "Documents, no schemas, pure chaos.",
  "PostgreSQL": "Relational integrity, tables, and pure logic.",
  "Git": "Commit early, push often, pray there are no merge conflicts.",
  "GitHub": "Where my code goes to get starred.",
  "Docker": "But it works on my machine!",
  "Machine Learning": "Calling .fit() and .predict() and hoping for the best.",
  "VS Code": "Dark mode obviously.",
};

const defaultLine = "Powering up modular workflows and pushing optimized code.";

const Skills = () => {
  const [activeSkill, setActiveSkill] = useState(null);

  // Flatten the nested skills array for the keyboard
  const allSkills = useMemo(() => {
    return skills.flatMap((category) => category.skills);
  }, []);

  return (
    <Box id="skills" sx={{ 
      minHeight: "100vh", py: { xs: 8, md: 14 }, 
      display: "flex", alignItems: "center", position: "relative" 
    }}>
      <Container maxWidth="xl">
        <Grid container spacing={4} alignItems="center">
          
          {/* Left Text Dashboard */}
          <Grid item xs={12} md={5}>
            <Stack spacing={2} sx={{ pl: { xs: 0, lg: 8 } }}>
              <Typography sx={{ 
                fontFamily: "'Inter', sans-serif", fontWeight: 800, 
                fontSize: { xs: "3rem", md: "5rem" }, color: "#e6e8ec", 
                letterSpacing: "-0.05em", lineHeight: 1 
              }}>
                SKILLS
              </Typography>
              <Typography sx={{ 
                fontFamily: "'JetBrains Mono', monospace", fontSize: "0.85rem", 
                color: "#6b7582", mb: 6 
              }}>
                (hint: press a key)
              </Typography>

              {activeSkill ? (
                <Box className="reveal visible" sx={{ mt: 4 }}>
                  <Typography variant="h2" sx={{ 
                    fontFamily: "'Playfair Display', serif", fontWeight: 700, 
                    fontSize: { xs: "2.5rem", md: "3.5rem" }, color: "#00f0ff",
                    mb: 1, textShadow: "0 0 15px rgba(0,240,255,0.4)"
                  }}>
                    {activeSkill.name}
                  </Typography>
                  <Typography sx={{ 
                    fontFamily: "'Inter', sans-serif", fontSize: "1.2rem", 
                    color: "#858d99", fontWeight: 300, lineHeight: 1.6, maxWidth: 400 
                  }}>
                    {wittyLines[activeSkill.name] || defaultLine}
                  </Typography>
                </Box>
              ) : (
                <Box className="reveal visible" sx={{ mt: 4, opacity: 0.5 }}>
                  <Typography variant="h2" sx={{ 
                    fontFamily: "'Playfair Display', serif", fontWeight: 700, 
                    fontSize: { xs: "2.5rem", md: "3.5rem" }, color: "#e6e8ec", mb: 1 
                  }}>
                    Idle...
                  </Typography>
                  <Typography sx={{ 
                    fontFamily: "'Inter', sans-serif", fontSize: "1.2rem", 
                    color: "#858d99", fontWeight: 300 
                  }}>
                    Awaiting system input. Select a module on the right board to view details.
                  </Typography>
                </Box>
              )}
            </Stack>
          </Grid>

          {/* Right 3D Keyboard */}
          <Grid item xs={12} md={7} sx={{ height: { xs: 500, md: 800 } }}>
            <SkillsKeyboard skills={allSkills} onSelect={setActiveSkill} />
          </Grid>
          
        </Grid>
      </Container>
    </Box>
  );
};

export default Skills;
